<script>

    import UsersService from '../$services/users.service'

    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'

    let loading = false
    let element = null

    async function getUsersReport() {
        
        loading = true
        const blob = await UsersService.getUsersReport()
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        let fileName = `reporte_usuarios`

        element.download = `${fileName}.xlsx`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }
</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Form on:submit={ getUsersReport }>
    <div class="columns">
        <div class="column">
            <Button type="submit" text="Descargar" icon="file" { loading } fullwidth />
        </div>
    </div>
</Form>